import React, { useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Header from "../../layouts/header";
import { saveCourseSurvey } from "../../api/server";

const questions = [
  {
    name: "debtStruggleDuration",
    label:
      "How long were you struggling with debt before you contacted a bankruptcy attorney?",
  },
  {
    name: "helpfulInformation",
    label: "What information would have helped you start the process sooner?",
  },
  {
    name: "bankruptcyAdvice",
    label:
      "What is the one thing you want people considering bankruptcy to know?",
  },
];

const initialValues = questions.reduce(
  (values, question) => ({ ...values, [question.name]: "" }),
  {}
);

const validationSchema = Yup.object(
  questions.reduce(
    (schema, question) => ({
      ...schema,
      [question.name]: Yup.string()
        .trim()
        .required("Answer is required")
        .max(2000, "Answer must be 2,000 characters or fewer"),
    }),
    {}
  )
);

const CourseSurvey = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const [postLoading, setPostLoading] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("id");
  const retake =
    queryParams.get("retake") !== null &&
    queryParams.get("retake") !== "null" &&
    queryParams.get("retake") !== "false";
  const isJoint = localStorage.getItem("isJoint") === "true";
  const targetUserId = userId || user.user.data.id;

  const handleSubmit = async (values) => {
    setPostLoading(true);
    try {
      await saveCourseSurvey(
        values,
        userId ? "admin" : "user",
        targetUserId,
        isJoint,
        retake
      );

      navigate(
        userId
          ? `/editstudent?id=${userId}&retake=${retake}`
          : `/creditcounseling?course=second&retake=${retake}`
      );
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Survey responses could not be saved. Please try again."
      );
    } finally {
      setPostLoading(false);
    }
  };

  return (
    <div className="step_form w-75 mx-auto course-survey">
      <Header />
      <div className="pt-4 mt-60">
        <h4 className="f-26 mb-5">Post-Bankruptcy Debtor Education</h4>
        <div className="head d-flex align-content-center ps-4">
          <span className="mb-0 fw-700">Course Survey</span>
        </div>
        <p className="mt-4 mb-4">
          Please answer the following questions based on your experience.
        </p>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, submitCount }) => (
            <Form noValidate>
              {questions.map((question, index) => (
                <div className="mb-4" key={question.name}>
                  <label className="fw-600 mb-2" htmlFor={question.name}>
                    {index + 1}. {question.label}
                  </label>
                  <Field
                    as="textarea"
                    className="form-control"
                    id={question.name}
                    name={question.name}
                    maxLength={2000}
                    rows={4}
                    aria-invalid={Boolean(
                      submitCount > 0 && errors[question.name]
                    )}
                  />
                  <ErrorMessage
                    name={question.name}
                    component="div"
                    className="error text-danger mt-2"
                  />
                </div>
              ))}

              <div className="btn_wrap mt-40 text-center">
                <button
                  type="submit"
                  disabled={postLoading}
                  className="btn_brnd"
                >
                  {postLoading ? (
                    <ThreeDots
                      height="20"
                      width="75"
                      radius="9"
                      color="#4fa94d"
                      ariaLabel="saving-survey"
                      wrapperClassName="spinner"
                      visible
                    />
                  ) : (
                    "Continue"
                  )}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CourseSurvey;
